module.exports = __webpack_public_path__ + "static/media/bts3.8506d3b2.jpg";